// src/components/AuthGuard.jsx
// Thin wrapper — provides a mount point for global auth side-effects if needed.
// Keeps the pattern consistent with x20-creative for future extensibility.
import React from "react";

const AuthGuard = ({ children }) => {
  return <>{children}</>;
};

export default AuthGuard;
